<ng-container>
  <app-form-group>
    <app-info class="formGroupLabel">
      <label>Vessel meets technical specifications ?</label>
      <div class="tooltipContent leftAligned">
        <strong>Technical specifications</strong>
        <ul>
          <li>IEC 80005-3 (under development)</li>
          <li>Plug 125A CEE 5-pole or 350A 3PX5</li>
          <li>Max. 350 Amps, 50 Hz, 400 V</li>
        </ul>
      </div>
    </app-info>
    <app-yes-no [(ngModel)]="shorePower.shorePowerDetails.vesselMeetsTechnicalSpecifications" required id="vesselMeetsTechnicalSpecifications" [disabled]=pinCodeReceived></app-yes-no>
  </app-form-group>
  <app-form-group>
    <app-info class="formGroupLabel">
      <label>Email address</label>
      <div class="tooltipContent">This email address will be used for communication concerning the ordering of shore power</div>
    </app-info>
    <input [(ngModel)]="shorePower.shorePowerDetails.organisation.emailAddress" id="shipEmailAddress" type="text" class="form-control" readonly>
  </app-form-group>
  <!--app-form-group>
    <app-info class="formGroupLabel">
      <label>Peak power demand (kW)</label>
      <div class="tooltipContent">If unknown, enter 0</div>
    </app-info>
    <input [(ngModel)]="shorePower.shorePowerDetails.peakPowerDemandInKW" id="peakPowerDemandInKW" type="number" min="0" class="form-control" required [readonly]=pinCodeReceived>
  </app-form-group>
  <app-form-group>
    <app-info class="formGroupLabel">
      <label>Average power demand (kW)</label>
      <div class="tooltipContent">
        If unknown, enter 0
      </div>
    </app-info>
    <input [(ngModel)]="shorePower.shorePowerDetails.averagePowerDemandInKW" id="averagePowerDemandInKW" type="number" min="0" class="form-control" required [readOnly]=pinCodeReceived>
  </app-form-group-->
</ng-container>
